/**
 * @fileoverview gRPC-Web generated client stub for org.couchers.api.galleries
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.26.1
// source: galleries.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var annotations_pb = require('./annotations_pb.js')
const proto = {};
proto.org = {};
proto.org.couchers = {};
proto.org.couchers.api = {};
proto.org.couchers.api.galleries = require('./galleries_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.api.galleries.GalleriesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.GetGalleryReq,
 *   !proto.org.couchers.api.galleries.PhotoGallery>}
 */
const methodDescriptor_Galleries_GetGallery = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/GetGallery',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.GetGalleryReq,
  proto.org.couchers.api.galleries.PhotoGallery,
  /**
   * @param {!proto.org.couchers.api.galleries.GetGalleryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.PhotoGallery.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.GetGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.PhotoGallery)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.PhotoGallery>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.getGallery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/GetGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_GetGallery,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.GetGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.PhotoGallery>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.getGallery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/GetGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_GetGallery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.AddPhotoToGalleryReq,
 *   !proto.org.couchers.api.galleries.PhotoGallery>}
 */
const methodDescriptor_Galleries_AddPhotoToGallery = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/AddPhotoToGallery',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.AddPhotoToGalleryReq,
  proto.org.couchers.api.galleries.PhotoGallery,
  /**
   * @param {!proto.org.couchers.api.galleries.AddPhotoToGalleryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.PhotoGallery.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.AddPhotoToGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.PhotoGallery)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.PhotoGallery>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.addPhotoToGallery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/AddPhotoToGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_AddPhotoToGallery,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.AddPhotoToGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.PhotoGallery>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.addPhotoToGallery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/AddPhotoToGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_AddPhotoToGallery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.RemovePhotoFromGalleryReq,
 *   !proto.org.couchers.api.galleries.PhotoGallery>}
 */
const methodDescriptor_Galleries_RemovePhotoFromGallery = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/RemovePhotoFromGallery',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.RemovePhotoFromGalleryReq,
  proto.org.couchers.api.galleries.PhotoGallery,
  /**
   * @param {!proto.org.couchers.api.galleries.RemovePhotoFromGalleryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.PhotoGallery.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.RemovePhotoFromGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.PhotoGallery)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.PhotoGallery>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.removePhotoFromGallery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/RemovePhotoFromGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_RemovePhotoFromGallery,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.RemovePhotoFromGalleryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.PhotoGallery>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.removePhotoFromGallery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/RemovePhotoFromGallery',
      request,
      metadata || {},
      methodDescriptor_Galleries_RemovePhotoFromGallery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.MovePhotoReq,
 *   !proto.org.couchers.api.galleries.PhotoGallery>}
 */
const methodDescriptor_Galleries_MovePhoto = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/MovePhoto',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.MovePhotoReq,
  proto.org.couchers.api.galleries.PhotoGallery,
  /**
   * @param {!proto.org.couchers.api.galleries.MovePhotoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.PhotoGallery.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.MovePhotoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.PhotoGallery)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.PhotoGallery>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.movePhoto =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/MovePhoto',
      request,
      metadata || {},
      methodDescriptor_Galleries_MovePhoto,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.MovePhotoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.PhotoGallery>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.movePhoto =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/MovePhoto',
      request,
      metadata || {},
      methodDescriptor_Galleries_MovePhoto);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.UpdatePhotoCaptionReq,
 *   !proto.org.couchers.api.galleries.PhotoGallery>}
 */
const methodDescriptor_Galleries_UpdatePhotoCaption = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/UpdatePhotoCaption',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.UpdatePhotoCaptionReq,
  proto.org.couchers.api.galleries.PhotoGallery,
  /**
   * @param {!proto.org.couchers.api.galleries.UpdatePhotoCaptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.PhotoGallery.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.UpdatePhotoCaptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.PhotoGallery)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.PhotoGallery>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.updatePhotoCaption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/UpdatePhotoCaption',
      request,
      metadata || {},
      methodDescriptor_Galleries_UpdatePhotoCaption,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.UpdatePhotoCaptionReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.PhotoGallery>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.updatePhotoCaption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/UpdatePhotoCaption',
      request,
      metadata || {},
      methodDescriptor_Galleries_UpdatePhotoCaption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.galleries.GetGalleryEditInfoReq,
 *   !proto.org.couchers.api.galleries.GetGalleryEditInfoRes>}
 */
const methodDescriptor_Galleries_GetGalleryEditInfo = new grpc.web.MethodDescriptor(
  '/org.couchers.api.galleries.Galleries/GetGalleryEditInfo',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.galleries.GetGalleryEditInfoReq,
  proto.org.couchers.api.galleries.GetGalleryEditInfoRes,
  /**
   * @param {!proto.org.couchers.api.galleries.GetGalleryEditInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.galleries.GetGalleryEditInfoRes.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.galleries.GetGalleryEditInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.galleries.GetGalleryEditInfoRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.galleries.GetGalleryEditInfoRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.galleries.GalleriesClient.prototype.getGalleryEditInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/GetGalleryEditInfo',
      request,
      metadata || {},
      methodDescriptor_Galleries_GetGalleryEditInfo,
      callback);
};


/**
 * @param {!proto.org.couchers.api.galleries.GetGalleryEditInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.galleries.GetGalleryEditInfoRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.galleries.GalleriesPromiseClient.prototype.getGalleryEditInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.galleries.Galleries/GetGalleryEditInfo',
      request,
      metadata || {},
      methodDescriptor_Galleries_GetGalleryEditInfo);
};


module.exports = proto.org.couchers.api.galleries;

